import React from 'react';
import { Alert, Typography } from 'antd';
import type { AdminProductValidationAlertProps } from '../../interfaces';

const { Text } = Typography;

const AdminProductValidationAlert: React.FC<AdminProductValidationAlertProps> = ({ summary }) => {
  if (!summary) {
    return null;
  }

  return (
    <Alert
      showIcon
      type="warning"
      className="admin-product-create__validation-alert"
      message="Complete required product fields before creating"
      description={(
        <div className="admin-product-create__validation-content">
          {summary.requiredSections.map((section) => (
            <div key={section.key} className="admin-product-create__validation-section">
              <Text strong>{section.title}</Text>
              <ul>
                {section.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
          {summary.recommendations.length > 0 && (
            <div className="admin-product-create__validation-section">
              <Text strong>Recommended</Text>
              <ul>
                {summary.recommendations.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    />
  );
};

export default AdminProductValidationAlert;
